const mutations = {
    'SET_BUSINESSES' (state, { businesses }) {
      state.businesses = businesses;
    },
    'SET_BUSINESS' (state, { business }) {
      state.business = business
    },
    'SET_BUSINESS_SERVICES' (state, value) {
      state.businessServices = value
    }
  }
  export default mutations